import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  Typography,
  Modal,
  ThemeProvider,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// import { makeStyles } from "@mui/material/styles";

import CheckIcon from "@mui/icons-material/Check";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { basicTheme } from "../../themes/customTheme";
import BackDropLoader from "../reusableComponents/BackDropLoader";
import { useDispatch } from "react-redux";
import SnackBars from "../reusableComponents/SnackBar";
import BasicTextfield from "../reusableComponents/BasicTextfield";
import BasicDropDown from "../reusableComponents/BasicDropDown";
import FormCard from "../formManagement/formCard";
import { editFromData } from "../../features/formManagement/formManagementAPIs";
import AutoCompleteDropdown from "../reusableComponents/AutoCompleteDropDown";
import OptionalDropDown from "../reusableComponents/OptionalDropDown";
import { getProjectData } from "../../features/projects/projectsAPIs";

const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  px: 6,
  boxShadow: 24,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflowY: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  scrollbarWidth: "thin",
  scrollbarColor: "transparent transparent",
};

// const useStyles = makeStyles(() => ({
//   closeBtnStyle: {
//     zoom: "2.2",
//     alignItems: "right",
//     color: "#444444",
//     cursor: "pointer",
//     "&:hover": { opacity: 0.7 },
//     maxHeight: "1rem",
//     maxWidth: "1rem",
//   },
//   textField: {
//     "& .MuiInputBase-input": {
//       border: "none", // Remove the border
//     },
//     "& .MuiInput-underline:before": {
//       border: "none", // Remove the underline
//     },
//     "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
//       border: "none", // Remove the underline on hover
//     },
//   },
// }));

const ButtonStyle = styled(Button)({
  backgroundColor: "#2D6A4F",
  color: "white",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

const CancelButtonStyle = styled(Button)({
  backgroundColor: "white",
  color: "#2D6A4F",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

export default function EditFormModal({
  openEditModal,
  handleClose = () => {},
  data = null,
  setFormSnackBarMessage = () => {},
  setFormSnackBarType = () => {},
  setReload = () => {},
  setOpenSuccessBox = () => {},
  setSuccessMessage = () => {},
  setOpenSuccessBoxType = () => {},
  languages = [],
}) {
  const { v4: uuidv4 } = require("uuid");
  // const classes = useStyles();
  const dispatch = useDispatch();
  const [id, setId] = useState(data ? (data.form?.id ? data.form.id : "") : "");
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const [formName, setFormName] = useState(
    data ? (data.form?.name ? data.form.name : "") : ""
  );
  const [formStatus, setFormStatus] = useState(
    data ? (data.is_active === true ? "Active" : "Inactive") : ""
  );
  const [formIcon, setFormIcon] = useState(data.icon);
  const [formIconList, setFormIconList] = useState([]);
  const [addFormSnackBar, setAddFormSnackBar] = useState(false);
  const [addFormSnackBarMessage, setAddFormSnackBarMessage] = useState("");
  const oldQuestions = data?.questions?.map((question) => ({ ...question }));
  const [questions, setQuestions] = useState(
    data ? data?.questions?.map((question) => ({ ...question })) : []
  );

  const basicError = {
    formName: "",
    formIcon: "",
    projects: "",
  };
  const [snackBarType, setSnackBarType] = useState("success");
  const [errors, setErrors] = useState(basicError);

  const formStatusList = ["Active", "Inactive"];
  const [loading, setLoading] = useState(false);

  const [projects, setProjects] = useState(data.project);
  const [projectList, setProjectList] = useState([{ id: "", name: "" }]);

  const languageSymbols = {
    en: "english",
    hi: "hindi",
    // pa: "punjabi",
    mr: "marathi",
    gu: "gujarati",
    // ta: "tamil",
    // te: "telugu",
    // kn: "kannada",
    // or: "odia",
  };

  const validateFormData = () => {
    //value = value.replace(/^\s+/g, "");
    let formNameError = "";
    let formIconError = "";
    let formProjectError = "";
    const ALPHA_NUMERIC_DASH_REGEX =
      /^[a-zA-Z0-9\s_]{1,}[\.]{0,1}[A-Za-z0-9\s_]{0,}$/;
    if (formName.trim() === "") {
      //setErrors({ ...errors, formName: "Form Name can't be empty" });
      //value = "";
      formNameError = "Form Name can't be empty";
    }
    if (formIcon === null) {
      //setErrors({...errors, formIcon: "Form Icon can't be empty"});
      formIconError = "Form Category can't be empty";
    }
    if (projects === null) {
      formProjectError = "Project can't be empty";
    }
    setErrors({
      ...errors,
      formIcon: formIconError,
      formName: formNameError,
      projects: formProjectError,
    });
    //setFormName(value);
  };

  const handleChangeFromName = (value) => {
    value = value.replace(/^\s+/g, "");
    const ALPHA_NUMERIC_DASH_REGEX =
      /^[a-zA-Z0-9\s_]{1,}[\.]{0,1}[A-Za-z0-9\s_]{0,}$/;
    if (value.trim() === "") {
      setErrors({ ...errors, formName: "Form Name can't be empty" });
      value = "";
    } else if (!ALPHA_NUMERIC_DASH_REGEX.test(value)) {
      setErrors({
        ...errors,
        formName: "Special characters are not allowed in Form Name",
      });
      value = "";
    } else {
      setErrors({ ...errors, formName: "" });
    }
    setFormName(value);
  };

  const handleChangeFormStatus = (event) => {
    setFormStatus(event.target.value);
  };

  const handleChangeFormIcon = (value) => {
    setFormIcon(value);
    setErrors({ ...errors, formIcon: "" });
  };

  const handleChangeProjects = (value) => {
    setProjects(value);
    setErrors({ ...errors, projects: "" });
  };

  useEffect(() => {
    if (projectList[0].id === "") {
      const params = { fields: ["id", "name"] };
      const fetchData = async () => {
        try {
          const response = await getProjectData(params);
          if (
            response != null &&
            response != undefined &&
            response.data !== null &&
            response.data !== undefined &&
            response.data.results !== null &&
            response.data.results !== undefined
          ) {
            setProjectList(response.data.results);
          } else {
            //   setAddFormSnackBarType("error");
            // setAddFormSnackBar(true);
            // setAddFormSnackBarMessage("Something went wrong on sever!")
            setOpenSuccessBox(true);
            setSuccessMessage("Something went wrong on sever!");
            setOpenSuccessBoxType("error");
          }
        } catch (error) {
          // setAddFormSnackBarType("error");
          // setAddFormSnackBar(true);
          // setAddFormSnackBarMessage("Not able to fetch projects, Please check server!");
          setOpenSuccessBox(true);
          setSuccessMessage("Not able to fetch projects, Please check server!");
          setOpenSuccessBoxType("error");
        }
      };
      fetchData();
    }
  }, []);

  const addNewQuestion = () => {
    const newQuestion = {
      response_type: "audio",
    };
    if(questions?.length>0){
      setQuestions([...questions, newQuestion]);
    }
  };

  const handleCloseByClearIcon = () => {
    setErrors(basicError);
    setFormName("");
    setFormStatus("");
    setProjects("");
    setAddFormSnackBar(false);
    setSnackBarType("success");
    setAddFormSnackBarMessage("");
    setFormSnackBarType("");
    setFormSnackBarMessage("");
    handleClose();
  };

  function transformQuestionsData(currentData) {
    return currentData.map((item) => {
      const uuid = uuidv4();
      const translations = {};
      Object.keys(languageSymbols).forEach((languageKey) => {
        const languageName = languageSymbols[languageKey];
        if (item[languageName]) {
          translations[languageKey] = item[languageName];
        }
      });
      return {
        id: item.id ? item.id : uuid,
        question: item.english, // Assuming English is always present
        translations,
        response_type: item.response_type.toLowerCase(),
        ...(["dropdown", "radio"].includes(
          item.response_type.toLowerCase()
        ) && { responses: item.responses }),
      };
    });
  }
  function checkIfQuestionsUpdated(old_questions, new_questions) {
    if (old_questions?.length !== new_questions?.length) return true;

    for (let i = 0; i < old_questions?.length; i++) {
      if (!objectsAreEqual(old_questions[i], new_questions[i])) {
        return true;
      }
    }
    return false;
  }
  function objectsAreEqual(obj1, obj2) {
    const str1 = JSON.stringify(obj1);
    const str2 = JSON.stringify(obj2);
    return str1 === str2;
  }

  const handleSaveData = async () => {
    // const lastQuestion = questions[questions?.length - 1].english.trim() === "";
    const isEnglishValidForAllQuestions = await questions?.every(
      (question) =>
        question.english !== undefined && question.english.trim() !== ""
    );
    const isHindiValidForAllQuestions = await questions?.every(
      (question) => question.hindi !== undefined && question.hindi.trim() !== ""
    );
    const isResponseValidForAllQuestions = await questions?.every((question) => {
      const isEnglishValid = !(
        (question?.response_type.toLowerCase() === "dropdown" ||
          question.response_type.toLowerCase() === "radio") &&
        (!question?.responses ||
          !question.responses.english ||
          question.responses.english.length < 2)
      );

      // const isHindiValid =
      //   !(
      //     (question.response_type.toLowerCase() === "dropdown" ||
      //       question.response_type.toLowerCase() === "radio") &&
      //     (!question.responses ||
      //       !question.responses.hindi ||
      //       question.responses.hindi.length < 2)
      //   );

      return isEnglishValid;
    });
    if (!isResponseValidForAllQuestions) {
      setOpenSuccessBox(true);
      setSuccessMessage(
        "Please enter valid number of responses for dropdown and radio in english language"
      );
      setOpenSuccessBoxType("error");
    } else if (
      errors.formName === "" &&
      formStatus !== "" &&
      formName !== "" &&
      questions?.length !== 0 &&
      formIcon !== null &&
      projects !== null &&
      isEnglishValidForAllQuestions &&
      // isHindiValidForAllQuestions &&
      isResponseValidForAllQuestions
    ) {
      var isActive = formStatus === "Active" ? true : false;
      // var project_ids = projects.map((item, index) => {
      //   return item.id;
      // });
      var data = {
        name: formName,
        is_active: isActive,
        icon: formIcon.id,
        created_by: "1",
        project: projects.id,
      };
      if (checkIfQuestionsUpdated(oldQuestions, questions)) {
        var formatted_questions = transformQuestionsData(questions);
        data["questions"] = formatted_questions;
      }

      try {
        setLoading(true);
        const response = await editFromData(data, id);
        setOpenSuccessBox(true);
        setSuccessMessage(response.data["message"]);
        setOpenSuccessBoxType("success");
        setReload(true);
        setLoading(false);
        handleClose();
      } catch (error) {
        setOpenSuccessBox(true);
        setSuccessMessage(error.response.data["message"]);
        setOpenSuccessBoxType("error");
        setLoading(false);
      }
    } else {
      validateFormData();
      setOpenSuccessBox(true);
      setSuccessMessage("Please fill all the required fields");
      setOpenSuccessBoxType("error");
    }
  };

  const handleChangeLanguage = (event) => {
    setSelectedLanguage(event.target.value);
  };

  return (
    <Modal open={openEditModal}>
      <Grid container sx={subGridStyle} spacing={1}>
        <ThemeProvider theme={basicTheme}>
          <Grid
            container
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "white",
              marginTop: 2,
              paddingTop: 2,
              // paddingTop: 4,
            }}
          >
            <Grid item xs={11}>
              <Typography variant="h4" style={{ marginBottom: 10 }}>
                Edit Form
              </Typography>
            </Grid>
            <Grid
              item
              xs={1}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <CloseRoundedIcon
                // className={classes.closeBtnStyle}
                onClick={handleCloseByClearIcon}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            xs={12}
            sx={{
              width: "90%",
            }}
          >
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Form Name
              </Typography>
              <BasicTextfield
                label="Enter Form Name"
                is_phone={false}
                handleChange={handleChangeFromName}
                is_disabled={false}
                index={1}
                error={errors.formName !== ""}
                helperText={errors.formName}
                required={true}
                value={formName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Form Status
              </Typography>
              <BasicDropDown
                text="Select Form Status"
                value={formStatus}
                handleChange={handleChangeFormStatus}
                menuList={formStatusList}
                error={false}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Form Category
              </Typography>
              <AutoCompleteDropdown
                label="Select Form Category"
                selectedOptions={formIcon}
                setSelectedOptions={handleChangeFormIcon}
                menuList={formIconList}
                error={errors.formIcon !== ""}
                required={true}
                type="icon"
                errorText={errors.formIcon}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Projects</Typography>
              <AutoCompleteDropdown
                width={230}
                menuList={projectList}
                // value={projects}
                selectedOptions={projects}
                onHighlightChange={(value) => {
                  handleChangeProjects(value);
                }}
                label="Select Projects"
                // error={false}
                required={true}
                error={errors.projects !== ""}
                errorText={errors.projects}
              />
            </Grid>
            <Grid item xs={8}>
              <Typography sx={{ fontFamily: "Inter", color: "#444444" }}>
                Add Questions
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Box
                display="flex"
                alignItems="center"
                bgcolor="#F5F5F5"
                p={2}
                borderRadius={20}
                width="250px"
                height="40px"
                padding="12px 16px"
              >
                <Typography
                  sx={{ fontFamily: "Inter", color: "#78828C", marginRight: 2 }}
                >
                  Translations
                </Typography>
                <OptionalDropDown
                  text={"Translations"}
                  id={selectedLanguage}
                  handleChange={handleChangeLanguage}
                  menuList={languages}
                  borderRadius="24px"
                  height="100%"
                  width="50%"
                />
              </Box>
            </Grid>
            {questions != null &&
              questions.map((item, index) => (
                <FormCard
                  key={index}
                  index={index}
                  edit={true}
                  question={item}
                  setQuestions={setQuestions}
                  selectedLanguage={selectedLanguage}
                  setSelectedLanguage={setSelectedLanguage}
                />
              ))}
            <Grid
              item
              xs={12}
              sm={12}
              sx={{
                marginLeft: 1,
                marginTop: 3,
                width: "80%",
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color:
                    questions?.length > 0 &&
                    (questions[questions?.length - 1].english === undefined ||
                      questions[questions?.length - 1].english.trim() === "")
                      ? "#AAAAAA" // Apply disabled style
                      : "#2D6A4F", // Apply normal style
                  cursor:
                    questions?.length > 0 &&
                    (questions[questions?.length - 1].english === undefined ||
                      questions[questions?.length - 1].english.trim() === "")
                      ? "default" // Change cursor to default for disabled link
                      : "pointer", // Use pointer cursor for clickable link
                  "&:hover": {
                    opacity:
                      questions?.length > 0 &&
                      (questions[questions?.length - 1].english === undefined ||
                        questions[questions?.length - 1].english.trim() === "")
                        ? 1 // Keep opacity at 1 for disabled link
                        : 0.7, // Reduce opacity for clickable link on hover
                  },
                }}
                onClick={
                  questions?.length > 0 &&
                  (questions[questions?.length - 1].english === undefined ||
                    questions[questions?.length - 1].english.trim() === "")
                    ? null // Don't execute the click handler for disabled link
                    : addNewQuestion // Execute the click handler for clickable link
                }
              >
                + Click here to add question
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            item
            sm={12}
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 1,
              backgroundColor: "white",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Grid item sx={{ margin: "30px" }}>
              <CancelButtonStyle
                variant="contained"
                name="cancel"
                onClick={handleClose}
              >
                Cancel
              </CancelButtonStyle>
            </Grid>
            <Grid item sx={{ margin: "30px" }}>
              <ButtonStyle
                variant="contained"
                name="add"
                startIcon={<CheckIcon size="large" />}
                onClick={handleSaveData}
              >
                Save
              </ButtonStyle>
            </Grid>
            {addFormSnackBar && (
              <SnackBars
                open={addFormSnackBar}
                handleClose={() => setAddFormSnackBar(false)}
                severity={snackBarType}
                message={addFormSnackBarMessage}
                autoHideDuration={6000}
                vertical="bottom"
                horizontal="center"
                position="absolute"
              />
            )}
          </Grid>
        </ThemeProvider>
        <BackDropLoader loading={loading} />
      </Grid>
    </Modal>
  );
}
